export interface INormalizedResponse<T = unknown> {
  payload: T;
  success: boolean;
  errorCode: null | string;
  errorMessage: null | string;
  isLegacyEnvelope: boolean;
}

export function normalizeResponseData<T>(
  data: unknown
): INormalizedResponse<T> {
  if (isCamelCaseEnvelope(data)) {
    return {
      payload: data.dataModel as T,
      success: data.success,
      errorCode: data.errorCode ?? null,
      errorMessage: data.errorMessage ?? null,
      isLegacyEnvelope: true
    };
  }

  if (isPascalCaseEnvelope(data)) {
    return {
      payload: data.DataModel as T,
      success:
        typeof data.Success === 'boolean'
          ? data.Success
          : !(data.ErrorCode || data.ErrorMessage),
      errorCode: data.ErrorCode ?? null,
      errorMessage: data.ErrorMessage ?? null,
      isLegacyEnvelope: true
    };
  }

  return {
    payload: data as T,
    success: true,
    errorCode: null,
    errorMessage: null,
    isLegacyEnvelope: false
  };
}

function isCamelCaseEnvelope(data: unknown): data is IResponseData {
  if (!isRecord(data)) {
    return false;
  }

  return (
    hasOwnProperty(data, 'dataModel') &&
    typeof data.success === 'boolean'
  );
}

function isPascalCaseEnvelope(
  data: unknown
): data is IResponseDataPascalCase {
  if (!isRecord(data)) {
    return false;
  }

  return (
    hasOwnProperty(data, 'DataModel') &&
    (hasOwnProperty(data, 'Success') ||
      hasOwnProperty(data, 'ErrorCode') ||
      hasOwnProperty(data, 'ErrorMessage'))
  );
}

function isRecord(data: unknown): data is Record<string, unknown> {
  return typeof data === 'object' && data !== null;
}

function hasOwnProperty(
  data: Record<string, unknown>,
  propertyName: string
): boolean {
  return Object.prototype.hasOwnProperty.call(data, propertyName);
}
